import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    commodityList: [],
    isLoading: false,
    error: null
}

export const CommodityReducer = createSlice({
    name: 'CommodityReducer',
    initialState,
    reducers: {
        initiateCommodityLoading: (state) => {
            state.isLoading = true
        },
        getCommoditySuccess: (state, action) => {
            state.isLoading = false
            state.commodityList = action.payload;
        },
        getCommodityFailure: (state, action) => {
            state.isLoading = false
            state.error = action.payload;
        },
        clearCommodityList: (state) => {
            state.commodityList = [];
        },
        clearError: (state) => {
            state.error = null
        },
    }
});


export const { getCommoditySuccess, initiateCommodityLoading, getCommodityFailure, clearError, clearCommodityList } = CommodityReducer.actions;

// Selectors
export const getCommoditySelector = (state) => {
    return state.CommodityReducer;
};

export default CommodityReducer.reducer;
